import { render, staticRenderFns } from "./orderdetail.vue?vue&type=template&id=260831d4&scoped=true&"
import script from "./orderdetail.vue?vue&type=script&lang=js&"
export * from "./orderdetail.vue?vue&type=script&lang=js&"
import style0 from "./orderdetail.vue?vue&type=style&index=0&id=260831d4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "260831d4",
  null
  
)

export default component.exports